function parseStringToFloat(baht) {
  // ไม่ใช่ตัวเลข ให้ 0.00
  if (isNaN(parseFloat(baht))) {
    console.warn('the number that you have parse float is not a number!')
    return parseFloat(`0.00`)
  } else {
    return parseFloat(baht)
  }
}

// format เป็น เงินไทย แบบ ฿ 300.00 หรือ ฿ 123.21
// example input = number(int or float)
function formatCurrency(baht) {
  return new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(baht)
}

export default baht => {
  // เป็น number หรือ string -> convert = number แล้วแปลงเป็นเงินไทย
  let $number //number type
  if (typeof baht === 'string') {
    $number = parseStringToFloat(baht)
  } else {
    // convert = float(yyy.xx)
    $number = baht.toFixed(2)
  }
  // แปลงสุลเงิน
  return formatCurrency($number)
}
